import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    // isHello:false,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page27/Key/E1answerKey.jpg",
    component: T6,
    inputSize: 100,
    hideBtnFooter: true,
    maxLength: 2,
    isHiddenCheck: true,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
      textTransform: "uppercase",
    },
    dragAndDrop: [
      {
        decreaseLeft: 15,
        decreaseTop: 5,
        dragImage: true, // Nếu kếu thả hình ảnh thì thêm thuộc tính này vào (đáp án đúng hoặc sai sẽ hiển thị icon)
        defaultPostion: [
          // lấy vị trí left + top ban đầu của ảnh cần kéo thả (4 vị trí tương ứng 4 ảnh)

          {
            top: 17,
            left: 189,
          },
          {
            top: 54,
            left: 643,
          },
        ],
        answers: [
          {
            // image 1
            top: 250, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 150, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 238,
            maxTop: 313,
            minLeft: -25,
            maxLeft: 281,
          },
          {
            // image 2
            top: 400, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 400, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 301,
            maxTop: 332,
            minLeft: 516,
            maxLeft: 863,
          },
        ],
      },
    ],

    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>

    //     `,
    //   },
    // ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Em hãy kéo hình vào ô thích hợp. </span>
        <video src="Audios/guide/p27_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; align-items: flex-start; max-width: 1050px;margin-top:-50px'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          Việt có hai cái kéo như hình dưới đây.

        </div> 
        <div style='width:27cm;margin-left:50px'>Hình cái kéo nào có hai lưỡi kéo tạo thành góc tù? Hình cái kéo nào có hai lưỡi kéo tạo thành góc nhọn?</div>
        <div id="drag" style="position: absolute; top: 17px; left: 189px; margin-top: 40px">
          <img
            src="/img/FriendsPlus/Page27/E1/1.png"
            alt=""
            width="270px"
            height="200px"
          />
          <div style="position: absolute;left: 94px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: 54px; left: 643px;">
          <img
          src="/img/FriendsPlus/Page27/E1/2.png"
            alt=""
            width="200px"
            height="200px"
          />
          <div style="position: absolute;left: 94px;top:67px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div style="display: flex; align-items: center;width: 1040px;">
          <div style="border: 1px solid black;margin-top: 200px;text-align:center;flex:1;height:255px">
            <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc nhọn</p>
          </div>

          <div style="border: 1px solid black;border-left: none; margin-top: 200px;text-align:center;flex:1;height:255px">
          <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc tù</p>
          </div>

         
        </div>
				
        `,
        answer: ["B", "A"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "",
    component: T6,
    isHiddenCheck: true,
    // protractor: true,
    hideBtnFooter: true,
    // isEssay:true,
    // maxLength:3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "dash",
      textAlign: "center",
    },
    inputSize: 150,
    textareaStyle: { width: 800 },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>

    //     `,
    //   },
    // ],
    clickImagePlayAudio: ["false", "true", "false"],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào số
        <span
        style="
          color: white;
          background-color: rgb(17,205,239);
          border-radius: 50%;
          padding: 3px 7px;
          margin-right: 5px;
        "
        >1</span>,
        <span
        style="
          color: white;
          background-color: rgb(17,205,239);
          border-radius: 50%;
          padding: 3px 7px;
          margin-right: 5px;
        "
        >2</span>,
        <span
        style="
          color: white;
          background-color: rgb(17,205,239);
          border-radius: 50%;
          padding: 3px 7px;
          margin-right: 5px;
        "
        >3</span>,



        trên chiếc bánh để chọn đáp án
        
        .</span>
        <video src="Audios/guide/p27_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],

    titleQuestion: [
      {
        num: "3",
        title: ` 
        Bạn An chọn một trong ba miếng bánh 
        <span
        style="
          color: white;
          background-color: rgb(17,205,239);
          border-radius: 50%;
          padding: 3px 10px;
          margin-right: 10px;
        "
        >1</span>,
        <span
        style="
          color: white;
          background-color: rgb(17,205,239);
          border-radius: 50%;
          padding: 3px 10px;
          margin-right: 10px;
        "
        >2</span
      >,
      <span
      style="
        color: white;
        background-color: rgb(17,205,239);
        border-radius: 50%;
        padding: 3px 10px;
        margin-right: 5px;
      "
      >3</span
    >
    như hình vẽ,biết rằng:
        `,
        color: "rgb(17,205,239)",
        // star: 1
      },
    ],
    // recorder: true,
    questionImage: [],
    questions: [
      {
        title: `
        
        <h3 style='margin-left:33px;font-size:22px;margin-top:10px'>- Miếng bánh mà An đã chọn không phải là miếng bé nhất</h3>
    <h3 style='margin-left:33px;font-size:22px'>- Góc đỉnh O ở hình miếng bánh mà An chọn không là góc bẹt</h3>
    <h3 style='margin-left:33px;font-size:22px'>- Hãy tìm miếng bánh bạn An đã chọn</h3>

        <div style="width: 1140px; position: relative">
      
      <img
      src="/img/FriendsPlus/page27/E2/1.png"
      alt="image"
          style="margin-left: 100px;width:600px;"
    />
    <div id ='answer' style="width: 60px;height: 60px;background: none;border-radius: 50%; position:absolute; top: 192px; left: 309px;z-index:10"></div>

    <div id ='answer' style="width: 60px;height: 60px;background: none;border-radius: 50%; position:absolute; top: 162px; left: 436px;z-index:10"></div>

    <div id ='answer' style="width: 60px;height: 60px;background: none;border-radius: 50%; position:absolute; top: 311px; left: 428px;z-index:10"></div>
      
    </div>
			`,
        answer: [""],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/page27/key/E3Key.png",
    component: T6,
    isHiddenCheck: true,
    hideBtnFooter: true,
    // protractor: true,
    // isEssay:true,
    // maxLength:3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "dash",
      textAlign: "center",
    },
    inputSize: 150,
    textareaStyle: { width: 800 },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>

    //     `,
    //   },
    // ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Các em kéo mỗi góc thích hợp vào các ô chữ góc nhọn, góc tù, góc bẹt </span>
        <video src="Audios/guide/p27_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],

    dragAndDrop: [
      {
        decreaseLeft: 15,
        decreaseTop: 5,
        dragImage: true, // Nếu kếu thả hình ảnh thì thêm thuộc tính này vào (đáp án đúng hoặc sai sẽ hiển thị icon)
        defaultPostion: [
          // lấy vị trí left + top ban đầu của ảnh cần kéo thả (4 vị trí tương ứng 4 ảnh)

          {
            top: -24,
            left: 0,
          },
          {
            top: -15,
            left: 466,
          },
          {
            top: -15,
            left: 658,
          },
          {
            top: -10,
            left: 282,
          },
          {
            top: -5,
            left: 807,
          },
          {
            top: -25,
            left: 1002,
          },
        ],
        answers: [
          {
            // image 1
            top: 429, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 368, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 145,
            maxTop: 289,
            minLeft: 369,
            maxLeft: 512,
          },
          {
            // image 2
            top: 153, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 28, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 145,
            maxTop: 275,
            minLeft: -20,
            maxLeft: 230,
          },
          {
            // image 3
            top: 200, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 28, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 190,
            maxTop: 280,
            minLeft: -10,
            maxLeft: 260,
          },
          {
            // image 4
            top: 435, // // lấy vị trí top của ảnh sau khi kéo thả
            left: -6, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: -15,
            maxTop: 246,
            minLeft: -5,
            maxLeft: 1047,
          },
          {
            // image 5
            top: 429, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 368, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 145,
            maxTop: 289,
            minLeft: 369,
            maxLeft: 530,
          },
          {
            // image 6
            top: 364, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 751, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 135,
            maxTop: 313,
            minLeft: 696,
            maxLeft: 1038,
          },
        ],
      },
    ],

    titleQuestion: [
      {
        num: "1",
        title: ` 
        Tìm các góc nhọn, góc tù, góc bẹt trong các góc sau.
        `,
        color: "rgb(130,219,189)",
        // star: 1
      },
    ],
    // recorder: true,
    questionImage: [],
    questions: [
      {
        title: `
        <div id="drag" style="position: absolute; top: -24px; left: 0px; margin-top: 40px">
          <img
            src="/img/FriendsPlus/Page27/E3/1.png"
            alt=""
            width="270px"
            height="120px"
          />
          <div style="position: absolute;left: 94px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -15px; left: 466px;">
          <img
          src="/img/FriendsPlus/Page27/E3/2.png"
            alt=""
            width="180px"
            height="140px"
          />
          <div style="position: absolute;left: 94px;top:67px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>


        <div id="drag" style="position: absolute; top: -15px; left: 658px;">
          <img
          src="/img/FriendsPlus/Page27/E3/3.png"
            alt=""
            width="135px"
          height="135px"
          />
          <div style="position: absolute;left: 70px;top:64px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -10px; left: 282px;">
          <img
          src="/img/FriendsPlus/Page27/E3/4.png"
            alt=""
            width="160px"
            height="140px"
          />
          <div style="position: absolute;left: 40px;top:65px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -5px; left: 807px;">
          <img
          src="/img/FriendsPlus/Page27/E3/5.png"
            alt=""
            width="240px"
            height="130px"
          />
          <div style="position: absolute;left: 72px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -25px; left: 1002px;">
          <img
          src="/img/FriendsPlus/Page27/E3/6.png"
            alt=""
            width="150px"
            height="160px"
          />
          <div style="position: absolute;left: 115px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>


        <div style="display: flex; align-items: center;width: 1140px;">
          <div style="border: 1px solid black;margin-top: 150px;text-align:center;flex:1;height:255px">
            <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc nhọn</p>
          </div>

          <div style="border: 1px solid black;border-left: none; margin-top: 150px;text-align:center;flex:1;height:255px">
          <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc tù</p>
          </div>

          <div style="border: 1px solid black;border-left: none;margin-top: 150px;text-align:center;flex:1;height:255px">
          <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc bẹt</p>
          </div>
        </div>
        
        
        
			`,
        answer: [""],
      },
    ],
  },
};

export default json;
